<template>
  <div id="yx_getaward">
    <!--大背景-->
    <img src="../../assets/list/yx(10).png" class="bk imgBlock absoluteItem" />
    <!--主体内容-->
    <div class="main">
      <img src="../../assets/list/yx(3).png" class="top-img bk imgBlock" />

      <div class="content relativeItem">
        <img src="../../assets/list/yx(11).png" class="item bk imgBlock" />

        <!--奖品展示-->
        <ul
          class="gifts flex-box absoluteItem centerX"
          :class="{ zhubo: num == 2, user: num == 3 }"
          v-if="gifts.length > 0"
        >
          <li>
            <p class="name apostrophe">{{ gifts[0].name }}</p>
            <div class="relativeItem">
              <img
                :src="gifts[0].image"
                class="absoluteItem centerImg imgBlock"
              />
            </div>
          </li>
          <span>+</span>
          <li>
            <p class="name apostrophe">{{ gifts[1].name }}</p>
            <div class="relativeItem">
              <img
                :src="gifts[1].image"
                class="absoluteItem centerImg imgBlock"
              />
            </div>
          </li>
          <span v-if="num == 3">+</span>
          <li v-if="num == 3">
            <p class="name apostrophe">{{ gifts[2].name }}</p>
            <div class="relativeItem">
              <img
                :src="gifts[2].image"
                class="absoluteItem centerImg imgBlock"
              />
            </div>
          </li>
        </ul>

        <!--领取按钮-->
        <div class="btn absoluteItem centerX">
          <a class="allA" v-if="get_gift == 0" @click="get_award"></a>
          <img src="../../assets/list/yx(8).png" class="imgBlock noevents-img"  v-if="get_gift == 0"/>
          <img src="../../assets/list/yx.png" class="imgBlock noevents-img"  v-else/>
        </div>
      </div>
    </div>
    <!--底部登录图案-->
    <img src="../../assets/list/yx(7).png" class="bottom-img imgBlock absoluteItem" />
  </div>
</template>

<script>
export default {
  name: "yx_getaward",
  data() {
    return {
      hide_item:false,//是否隐藏的标识
      num: 3, //2主播 3用户
      get_gift:0,//标识是否已经领取
      gifts:[],//礼物列表
    };
  },
  methods: {
    /**获取奖品信息 */
    get_gifts() {
      let _this = this;
      this.$jsonp(this.$apis("yx_award_gift", "app"), {type:this.$route.query.type}, (res) => {
        _this.get_gift = res.data.data.get_gift;
        _this.gifts = res.data.data.data;
      });
    },

    /**领取奖品 */
    get_award() {
      let _this = this;
      this.$jsonp(this.$apis("yx_get_award", "app"), {type:this.$route.query.type}, (res) => {
        if (res.data.data.status == 1) {
          //领取成功
          _this.get_gift = 1;
          _this.$tool.tipImg('领取成功','success');
        }else{
          _this.$tool.tipImg(res.data.data.msg,'error');
        }
      });
    },

  },
  mounted: function () {
    this.$tool.setTitle("欢乐今宵");
    this.num = parseInt(this.$route.query.type * 1);
    if (this.num == 1) {
      this.num = 3;
    }
    this.get_gifts();
  },
};
</script>

<style scoped>
#yx_getaward {
  position: relative;
  overflow-y: hidden;
  min-height: 100vh;
}
.kb {
  z-index: 0;
  width: 100%;
  top: 0;
  left: 0;
}
.main {
  position: relative;
  z-index: 2;
  transform: translateY(-12px);
}
.top-img {
  transform: translateY(-20px);
}
.bottom-img {
  z-index: 1;
  width: 100%;
  left: 0;
  bottom: 1.7rem;
}

/**内容宽度 */
.item {
  width: 93%;
  margin: 0 auto;
}
.b-main-img {
  margin-bottom: 1rem;
}
.content {
  transform: translateY(-5.5rem);
}
.btn {
  width: 56%;
  bottom: 18%;
}

.gifts {
  justify-content: center;
  align-items: center;
  top: 23%;
}
.gifts li {
  border-radius: 8px;
  background: #ffe5dc;
  overflow: hidden;
}
.gifts .name {
  text-align: center;
  color: #fff;
  font-weight: bold;
  background-color: #ff748a;
}
.gifts div {
  overflow: hidden;
  width: 100%;
}
.gifts img {
  max-width: 80%;
}
.gifts span {
  font-size: 1.25rem;
  margin: 0 1.1875rem;
  color: #ff748a;
}

/**主播礼物 */
.zhubo li {
  width: 4.5625rem;
  height: 5.5rem;
}
.zhubo .name {
  padding: 2px 2px;
  font-size: 0.75rem;
}
.zhubo div {
  height: 4.0625rem;
}

/**用户礼物 */
.user {
  top: 27%;
}
.user li {
  width: 4.0625rem;
  height: 4.6875rem;
}
.user .name {
  padding: 2px 2px;
  font-size: 0.75rem;
}
.user div {
  height: 3.4375rem;
}
.user img {
  max-width: 70%;
}
.user span {
  margin: 0 0.375rem;
}
</style>
